import { TOGGLE_MAP_VIEW } from '../actions'
import { createToggleReducer } from '../../../utility/state'

/**
 * @typedef {boolean} MapViewState Whether map view is activated for XS screens
 */

/**
 * @param {MapViewState} initialState
 * @returns {(state: MapViewState, action: Object) => MapViewState}
 */
export default function mapViewReducer(initialState) {
    return createToggleReducer(initialState, TOGGLE_MAP_VIEW)
}
